<div class="wrap">

  <div class="detail-head-box">
    <div class="head-box">{{ dispTxt }}</div>
    <div class="menu-box">
      <span class="help-btn-box">
        <button type="button" class="help-btn" (click)="OpenSaseungHelp()">도움말</button>
      </span>
      <span><a class="close-btn" (click)="onClose()"></a></span>
    </div>
  </div>

  <div #container
       class="detail-body-box"
       (scroll)="onScroll($event)">
    <div class="detail-item-list">
      <app-saseung3-item class="item-box"
                        *ngFor="let saseung3 of ll?.getList()"
                        [saseung3]="saseung3"
                        [showHangul]="showHangul"
                        [showBookmark]="true">
      </app-saseung3-item>

      <div class="item-box reload-icon"
                 *ngIf="!ll?.IsComplete()">
        <img #reload src="assets/img/loading_icon.gif">
      </div>

      <div class="item-box no-result"
           *ngIf="ll?.getTotalCount() === 0">
        <div class="img-box">
          <img src="assets/img/img_menu_tiger.svg">
        </div>
        <div class="keyword-no-result-box">
          문자가 없습니다.
        </div>
      </div>
    </div>

  </div>

</div>
